import _ from 'lodash';

export function getFieldsDifferenceBetweenTwoObjects(obj1, obj2) {
  const compareField = field => {
    if (
      [
        'isAmp',
        'bypassUnsubscription',
        'ampReplaceMagicLink',
        'isRateLimitExcluded',
        'enablePauseLink',
      ].indexOf(field) >= 0
    ) {
      return Boolean(obj1[field]) === Boolean(obj2[field]);
    }
    return _.isEqual(obj1[field], obj2[field]);
  };

  const fields = [];
  for (const key of Object.keys(obj1)) {
    if (!compareField(key)) {
      fields.push(key);
    }
  }
  return fields;
}

export const mapFieldToReadableText = {
  isAmp: 'AMP Email',
  template: 'Template Content',
  ampTemplate: 'AMP Template Content',
  textTemplate: 'Text Template Content',
  subject: 'Subject',
  categoryId: 'Category',
  emailTypeId: 'Email Type',
  name: 'Name',
  ampReplaceMagicLink: 'AMP Replace Magic Link',
  forceChoose: 'Sent Through',
  bypassUnsubscription: 'Bypass Unsubscription',
  isRateLimitExcluded: 'Relaxed Throttling',
  enablePauseLink: 'Enable Pause Link',
};
